export default __webpack_public_path__ + "static/media/hippoHeight.cbf48c98.jpg";